import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';

const plans = [
  { id: 'essentials', name: 'Essentials', price: 45, popular: false, desc: 'For first-time filers', features: ['Case review & assessment', 'Basic trademark search', 'State e-filing', 'Direct hit search', 'Dedicated case manager'] },
  { id: 'standard', name: 'Standard', price: 145, popular: true, desc: 'For growing businesses', features: ['Everything in Essentials', 'Comprehensive search', 'Risk evaluation report', 'Cease & desist template', 'Account manager', '100% approval guarantee'] },
  { id: 'professional', name: 'Professional', price: 299, popular: false, desc: 'For established brands', features: ['Everything in Standard', 'Attorney review & filing', 'Monitoring (3 months)', 'Refusal risk assessment', 'Complete paperwork'] },
  { id: 'enterprise', name: 'Enterprise', price: 599, popular: false, desc: 'Maximum protection', features: ['Everything in Professional', 'IP attorney filing', 'Federal search (all states)', 'Cease & desist letter', 'Same day filing', 'Monitoring (1 year)', '24/7 access', '100% guarantee'] }
];

const LPPricingSection = ({ onOpenModal }) => (
  <section className="py-24 bg-[#F9F8F6]" data-testid="lp-pricing-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="text-center mb-16">
        <p className="eyebrow mb-4">Transparent Pricing</p>
        <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter mb-4">Fixed-fee protection</h2>
        <p className="font-body text-[#4A5D53] max-w-xl mx-auto text-sm">Every package includes licensed IP attorney review. Select the level appropriate for your enterprise.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {plans.map((plan, i) => (
          <div key={i} className={`rounded-3xl p-8 border flex flex-col ${plan.popular ? 'bg-[#1A3628] border-[#1A3628] text-white' : 'bg-white border-[#D5D1C8] hover-lift'}`} data-testid={`lp-pricing-card-${plan.id}`}>
            {plan.popular && <div className="bg-[#C85A40] text-white text-xs font-body font-medium px-4 py-1.5 rounded-full self-start mb-4">Recommended</div>}
            <p className={`font-body text-xs uppercase tracking-widest mb-1 ${plan.popular ? 'text-white/60' : 'text-[#C85A40]'}`}>{plan.desc}</p>
            <h3 className={`font-display text-xl font-medium mb-4 ${plan.popular ? 'text-white' : 'text-[#111C16]'}`}>{plan.name}</h3>
            <div className="mb-6">
              <span className={`font-display text-4xl font-bold ${plan.popular ? 'text-[#C85A40]' : 'text-[#1A3628]'}`}>${plan.price}</span>
              <span className={`font-body text-xs ml-1 ${plan.popular ? 'text-white/50' : 'text-[#4A5D53]'}`}>+ USPTO fees</span>
            </div>
            <div className="flex-1 space-y-3 mb-6">
              {plan.features.map((f, j) => (
                <div key={j} className="flex items-start gap-2">
                  <CheckCircle className={`h-4 w-4 mt-0.5 flex-shrink-0 ${plan.popular ? 'text-[#C85A40]' : 'text-[#C85A40]'}`} strokeWidth={1.5} />
                  <span className={`font-body text-sm ${plan.popular ? 'text-white/80' : 'text-[#4A5D53]'}`}>{f}</span>
                </div>
              ))}
            </div>
            <Button onClick={() => onOpenModal(`Get Started - ${plan.name}`)} className={`w-full btn-hover ${plan.popular ? 'bg-[#C85A40] hover:bg-[#A64730] text-white' : 'bg-[#1A3628] hover:bg-[#11241A] text-white'}`} data-testid={`lp-pricing-cta-${plan.id}`}>
              Register your Trademark
            </Button>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default LPPricingSection;
